import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleContainer } from '@weezevent/nacre';
import Style from './../serviceForm.module.css';

export default function TicketForm({ formState, onChangeForm }) {
    const { t } = useTranslation();

    return (
        <ToggleContainer
            className={Style['toggle-container']}
            helpLabel={t('ticket.services.form.content.advanced.toggleRotateBarcodeTooltip')}
            checked={formState.config?.rotate_barcode}
            title={t('ticket.services.form.content.advanced.toggleRotateBarcode')}
            onChange={(synth, { checked }) => {
                let conf = { ...formState.config, rotate_barcode: checked };
                onChangeForm('config', conf);
            }}
        />
    );
}
